module.exports = __webpack_public_path__ + "assets/img/66_525_1.8aac81ac.jpg";